import { InformationCircleIcon } from '@heroicons/react/20/solid';
import React from "react";

import BaseField from "../input/BaseInputProps";

export interface NoticeField extends BaseField {
  type: 'notice';
  message: string;
};


function NoticeMessage({ message }: { message: string }) {
  return (
    <div className="rounded-md bg-bondi-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon className="h-8 w-8 text-bondi-blue-400" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-2xl text-bondi-blue-700">{message}</p>
        </div>
      </div>
    </div>
  );
}

export default NoticeMessage;
